"use strict";

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var moment = require("moment");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var Parser_1 = require("../../core/model/data-dictionary/Parser");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var PropDesc_1 = require("../../core/model/data-dictionary/PropDesc");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var NumberInRangeValidator_1 = require("../../core/model/data-dictionary/validators/NumberInRangeValidator");

var StringLengthValidator_1 = require("../../core/model/data-dictionary/validators/StringLengthValidator");

var DomainObject_1 = require("../../core/model/DomainObject");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var FlagSet_1 = require("../../core/model/FlagSet");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");

var utils_1 = require("../../core/utils");

var UserInfo_1 = require("../../user/model/UserInfo");

var CoordinatorFlags_1 = require("./CoordinatorFlags");

var CreationSource_1 = require("./CreationSource");

var WindowDerivedData_1 = require("./WindowDerivedData");

var WindowSimulation_1 = require("./WindowSimulation");

var WindowStateEnum_1 = require("./WindowStateEnum");

var WindowWarningFlag_1 = require("./WindowWarningFlag");
/**
 * <p>Data structure to encapsulate aggregated values of {@link SystemRegularVolume} for entire {@link Window}. Further
 * more includes and {@link WindowItemVolumesMap}.</p>
 *
 * @author JMe
 */


var WindowVolumesDesc =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowVolumesDesc, _DomainObject_1$Domai);

  /**
   * @param systemVolume Aggregated value of system volume to entire {@link Window window} from associated {@link WindowItem items}.
   * @param regularVolume Aggregated value of regular volume to entire {@link Window window} from associated {@link WindowItem items}.
   * @param itemsVolumes Mapping of {@link WindowItem items} and associated {@link SystemRegularVolume volumes}.
   */
  function WindowVolumesDesc(systemVolume, regularVolume, itemsVolumes) {
    var _this;

    _classCallCheck(this, WindowVolumesDesc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowVolumesDesc).call(this));
    _this.systemVolume = systemVolume;
    _this.regularVolume = regularVolume;
    _this.itemsVolumes = itemsVolumes;
    return _this;
  }

  return WindowVolumesDesc;
}(DomainObject_1.DomainObject);

exports.WindowVolumesDesc = WindowVolumesDesc;
/**
 * @author Radek Beran
 */
// tslint:disable-next-line:max-classes-per-file

var WindowPromoVolumesDesc =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(WindowPromoVolumesDesc, _DomainObject_1$Domai2);

  /**
   * @param itemsPromoVolumes Mapping of {@link WindowItem items} and associated {@link PromoVolumeInfo promo volume infos}.
   */
  function WindowPromoVolumesDesc(itemsPromoVolumes) {
    var _this2;

    _classCallCheck(this, WindowPromoVolumesDesc);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(WindowPromoVolumesDesc).call(this));
    _this2.itemsPromoVolumes = itemsPromoVolumes;
    return _this2;
  }

  return WindowPromoVolumesDesc;
}(DomainObject_1.DomainObject);

exports.WindowPromoVolumesDesc = WindowPromoVolumesDesc;
/**
 * Entity representing Window that is main component of Promotion. Promotions typically consists
 * from one or more windows.
 *
 * Window is container for WindowItems (representation of products in promotion).
 *
 * @author JMt
 */
// tslint:disable-next-line:max-classes-per-file

var Window =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(Window, _StateDomainObject_1$);

  /**
   * Creates new object of window.
   *
   * @param id the id of window
   * @param externalId
   * @param workflowCaseId workflow case ID
   * @param workflowState state of workflow
   * @param workflowModified last modification
   * @param workflowNote last note
   * @param name window name
   * @param dateFrom start date - first moment of window validity
   * @param dateTo end date - last moment of window validity, i.e. dateTo is inclusive
   * @param ecommerce whether this is window of e-commerce promotion
   * @param forecastCoordinatorFlag - flag object used for coordinator role
   * @param promotionId id of promotion this window is linked to
   * @param portfolio - id of level 4 category of products (CM category)
   * @param priceValidityStart promo price validity start date
   * @param priceValidityEnd promo price validity end date
   * @param leafletDescription
   * @param leafletPageNo (leaflet) page number
   * @param marketingComment Marketing comment (LOG-7473 and RFC 363).
   * @param windowTypeId
   * @param themeId
   * @param created date of window creation
   * @param createdBy user id
   * @param modified last modification date
   * @param modifiedBy user
   * @param ownedBy
   * @param stateFlags
   * @param simulation Contains values that are simulated. Will be exist when the forecast simulation is created.
   * @param dummy Window can be created in the forecast simulation as dummy
   * @param dummyOriginId
   * @param classification
   * @param derivedData data derived from windowItems to be displayed in the window overview
   * @param processed defines whether an instance was processed (used primarily for import)
   * @param warningFlags
   * @param snapshotOriginId string | null
   * @param source
   */
  function Window(id, externalId, workflowCaseId, workflowState, workflowModified, workflowNote, name, dateFrom, dateTo, ecommerce, forecastCoordinatorFlag, promotionId, portfolio, priceValidityStart, priceValidityEnd, leafletDescription, leafletPageNo, marketingComment, windowTypeId, themeId, created, createdBy, modified, modifiedBy, ownedBy, stateFlags, simulation, // Forecast simulation
  dummy, // Forecast simulation
  dummyOriginId, // Forecast simulation
  classification, derivedData, processed, warningFlags) {
    var _this3;

    var snapshotOriginId = arguments.length > 33 && arguments[33] !== undefined ? arguments[33] : null;
    var source = arguments.length > 34 && arguments[34] !== undefined ? arguments[34] : CreationSource_1.CreationSource.NOT_AVAILABLE;

    _classCallCheck(this, Window);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Window).call(this, stateFlags));
    _this3.id = id;
    _this3.externalId = externalId;
    _this3.workflowCaseId = workflowCaseId;
    _this3.workflowState = workflowState;
    _this3.workflowModified = workflowModified;
    _this3.workflowNote = workflowNote;
    _this3.name = name;
    _this3.dateFrom = dateFrom;
    _this3.dateTo = dateTo;
    _this3.ecommerce = ecommerce;
    _this3.forecastCoordinatorFlag = forecastCoordinatorFlag;
    _this3.promotionId = promotionId;
    _this3.portfolio = portfolio;
    _this3.priceValidityStart = priceValidityStart;
    _this3.priceValidityEnd = priceValidityEnd;
    _this3.leafletDescription = leafletDescription;
    _this3.leafletPageNo = leafletPageNo;
    _this3.marketingComment = marketingComment;
    _this3.windowTypeId = windowTypeId;
    _this3.themeId = themeId;
    _this3.created = created;
    _this3.createdBy = createdBy;
    _this3.modified = modified;
    _this3.modifiedBy = modifiedBy;
    _this3.ownedBy = ownedBy;
    _this3.stateFlags = stateFlags;
    _this3.simulation = simulation;
    _this3.dummy = dummy;
    _this3.dummyOriginId = dummyOriginId;
    _this3.classification = classification;
    _this3.derivedData = derivedData;
    _this3.processed = processed;
    _this3.warningFlags = warningFlags;
    _this3.snapshotOriginId = snapshotOriginId;
    _this3.source = source;
    return _this3;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(Window, [{
    key: "getSimulationConflictValues",

    /**
     * Returns values of window attributes, that can be simulated.
     */
    value: function getSimulationConflictValues() {
      return [this.windowTypeId, this.name, this.priceValidityStart, this.priceValidityEnd, this.dateFrom, this.dateTo, this.portfolio, this.themeId, this.leafletDescription, this.leafletPageNo];
    }
  }, {
    key: "isCopyable",
    value: function isCopyable() {
      return true;
    }
  }, {
    key: "isMovable",
    value: function isMovable() {
      return this.workflowState !== null && Window.MOVABLE_STATES.contains(this.workflowState);
    }
  }, {
    key: "durationInDays",
    value: function durationInDays() {
      return this.dateTo.diff(this.dateFrom, 'days') + 1;
    }
  }, {
    key: "isFCApprovalRequired",
    value: function isFCApprovalRequired() {
      return this.forecastCoordinatorFlag ? !this.forecastCoordinatorFlag.coordinatorAgreed : false;
    }
  }, {
    key: "isCanceled",
    value: function isCanceled(promotion) {
      if (promotion.id !== this.promotionId) {
        throw new Error("Promotion ids don't match!");
      }

      return promotion.isCanceled() || this.workflowState === WindowStateEnum_1.WindowStateEnum.Canceled;
    }
  }, {
    key: "withAppliedSimulation",
    value: function withAppliedSimulation(simulation) {
      var applyRejected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (simulation.originId === null) {
        throw new Error("Unset originId when applying simulation values ".concat(JSON.stringify(simulation), " to window ").concat(this.id));
      }

      function getSimValue(a, b) {
        if (!utils_1.Utils.isNull(a) && (applyRejected || !applyRejected && !a.isRejected())) {
          return a.simulatedValue;
        }

        return b;
      }

      return this.copyMulti({
        name: getSimValue(simulation.name, this.name),
        windowTypeId: getSimValue(simulation.windowTypeId, this.windowTypeId)
      });
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new Window(mat.id, mat.externalId, mat.workflowCaseId, mat.workflowState, mat.workflowModified, mat.workflowNote, mat.name, mat.dateFrom, mat.dateTo, mat.ecommerce, mat.forecastCoordinatorFlag, mat.promotionId, mat.portfolio, mat.priceValidityStart, mat.priceValidityEnd, mat.leafletDescription, mat.leafletPageNo, mat.marketingComment, mat.windowTypeId, mat.themeId, mat.created, mat.createdBy, mat.modified, mat.modifiedBy, mat.ownedBy, mat.stateFlags, mat.simulation, mat.dummy, mat.dummyOriginId, mat.classification, mat.derivedData, mat.processed, mat.warningFlags, mat.snapshotOriginId, mat.source);
    }
  }, {
    key: "isSnapshotted",
    value: function isSnapshotted(workflowState) {
      return workflowState !== null && Window.STATES_CHANGED_FOR_APPROVED_SNAPSHOTS.contains(workflowState);
    }
  }]);

  return Window;
}(StateDomainObject_1.StateDomainObject);

exports.Window = Window;
Window.DOCUMENT_TYPE = 'Window';
Window.EMPTY_LIST = immutable_1.List();
/** States in which is possible to copy the window */

Window.MOVABLE_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Concept, WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.Canceled, WindowStateEnum_1.WindowStateEnum.RejectedApproval);
/** States in which is possible to recalculate sites data of all window items that belong to a window */

Window.SITES_DATA_RECALCULATION_ENABLED_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Concept, WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.RejectedApproval, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.RejectedChange);
/** States that can be displayed in simulation */

Window.SIMULATED_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.RejectedChange, WindowStateEnum_1.WindowStateEnum.RejectedApproval);
/** states to be shown in forecast change report */

Window.FORECAST_CHANGE_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.RejectedApproval, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.RejectedChange);
/** States in which promo volume threshold should be checked */

Window.PROMO_VOLUME_THRESHOLD_TARGET_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.RejectedChange);
/** States in which system volume threshold should be checked */

Window.SYSTEM_VOLUME_THRESHOLD_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.RejectedChange, WindowStateEnum_1.WindowStateEnum.Finalized);
/** Windows that should be in Approval CD report */

Window.ACD_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.RejectedApproval);
/** Windows with approved values */

Window.STD_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Finalized);
/** Windows with unapproved values */

Window.UN_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.RejectedApproval, WindowStateEnum_1.WindowStateEnum.RejectedChange, WindowStateEnum_1.WindowStateEnum.Changed);
/** Windows that should be in Promotion Performance Report */

Window.PPR_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Finalized, WindowStateEnum_1.WindowStateEnum.Active, WindowStateEnum_1.WindowStateEnum.Finished, WindowStateEnum_1.WindowStateEnum.Evaluated, // Rejected and changed states must be included so the "Include rejected windows" functionality works
WindowStateEnum_1.WindowStateEnum.RejectedApproval, WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.RejectedChange);
/** Windows that should be in Window Performance Report */

Window.WPR_STATES = immutable_1.Set.of(WindowStateEnum_1.WindowStateEnum.Concept, WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Finalized, WindowStateEnum_1.WindowStateEnum.Active, WindowStateEnum_1.WindowStateEnum.Finished, WindowStateEnum_1.WindowStateEnum.Evaluated, // Rejected and changed states must be included so the "Include rejected windows" functionality works
WindowStateEnum_1.WindowStateEnum.RejectedApproval, WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.RejectedChange);
/** Windows that should be in PPR & WPR. Common services */

Window.PR_STATES = immutable_1.Set.of(WindowStateEnum_1.WindowStateEnum.Concept, WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Finalized, WindowStateEnum_1.WindowStateEnum.Active, WindowStateEnum_1.WindowStateEnum.Finished, WindowStateEnum_1.WindowStateEnum.Evaluated, WindowStateEnum_1.WindowStateEnum.RejectedApproval, WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.RejectedChange);
/** Windows that should be in Shelfplanning Report */

Window.SHELF_PLANNING_STATES = immutable_1.List.of(WindowStateEnum_1.WindowStateEnum.Prepared, WindowStateEnum_1.WindowStateEnum.Approved, WindowStateEnum_1.WindowStateEnum.Finalized, WindowStateEnum_1.WindowStateEnum.Active, WindowStateEnum_1.WindowStateEnum.Finished, WindowStateEnum_1.WindowStateEnum.Evaluated, WindowStateEnum_1.WindowStateEnum.Canceled);
/**
 * LOG-6345: Window data for these window states should be loaded as their last approved snapshots
 * if "Include rejected windows" is turned off (for some reports).
 */

Window.STATES_CHANGED_FOR_APPROVED_SNAPSHOTS = immutable_1.Set.of(WindowStateEnum_1.WindowStateEnum.RejectedApproval, WindowStateEnum_1.WindowStateEnum.Changed, WindowStateEnum_1.WindowStateEnum.RejectedChange);
Window.EMPTY = new Window(utils_1.Utils.VOID_ID, 'void', null, null, null, null, 'void', moment('2000-01-01T00:00:00Z'), moment('2000-01-01T00:00:00Z'), false, null, utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, null, null, null, null, null, utils_1.Utils.VOID_ID, null, moment('2000-01-01T00:00:00Z'), UserInfo_1.UserInfo.empty(), moment('2000-01-01T00:00:00Z'), UserInfo_1.UserInfo.empty(), UserInfo_1.UserInfo.empty(), FlagSet_1.FlagSet.of(EntityStateFlag_1.EntityStateFlag), null, false, utils_1.Utils.VOID_ID, null, WindowDerivedData_1.WindowDerivedData.empty(), false, new FlagSet_1.FlagSet(WindowWarningFlag_1.WindowWarningFlag), null);

Window.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Window.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    workflowCaseId: builder.opt(builder.str('workflowCaseId')),
    workflowState: builder.opt(builder.senum('workflowState', WindowStateEnum_1.WindowStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.WindowWorkflowState)),
    workflowModified: builder.opt(builder.date('workflowModified', DateParser_1.DateParser.ISO_PATTERN)),
    workflowNote: builder.opt(builder.str('workflowNote', new StringLengthValidator_1.StringLengthValidator(1, 255))),
    name: builder.trimStr('name', new StringLengthValidator_1.StringLengthValidator(1, 255)),
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    ecommerce: builder.bool('ecommerce'),
    forecastCoordinatorFlag: builder.opt(builder.obj('forecastCoordinatorFlag', CoordinatorFlags_1.CoordinatorFlags.schema, function (mat) {
      return CoordinatorFlags_1.CoordinatorFlags.fromDataDict(mat);
    })),
    promotionId: builder.str('promotionId'),
    portfolio: builder.str('portfolio'),
    priceValidityStart: builder.opt(builder.date('priceValidityStart', DateParser_1.DateParser.ISO_PATTERN)),
    priceValidityEnd: builder.opt(builder.date('priceValidityEnd', DateParser_1.DateParser.ISO_PATTERN)),
    leafletDescription: builder.opt(builder.str('leafletDescription', new StringLengthValidator_1.StringLengthValidator(1, 200)).withDescription({
      multiline: true
    })),
    leafletPageNo: builder.opt(builder.num('leafletPageNo', new NumberInRangeValidator_1.NumberInRangeValidator(1, 999))),
    marketingComment: builder.opt(builder.str('marketingComment', new StringLengthValidator_1.StringLengthValidator(1, 20)).withDescription({
      multiline: true
    })),
    windowTypeId: builder.lookup('windowTypeId', CodebookLookupSequence_1.CodebookLookupSequence.WindowTypes),
    themeId: builder.opt(builder.lookup('themeId', CodebookLookupSequence_1.CodebookLookupSequence.Theme)),
    created: builder.date('created', DateParser_1.DateParser.ISO_PATTERN),
    createdBy: builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    modified: builder.date('modified', DateParser_1.DateParser.ISO_PATTERN),
    modifiedBy: builder.obj('modifiedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    ownedBy: builder.obj('ownedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    simulation: builder.opt(builder.obj('simulation', WindowSimulation_1.WindowSimulation.schema, function (mat) {
      return WindowSimulation_1.WindowSimulation.fromDataDict(mat);
    })),
    dummy: builder.bool('dummy'),
    dummyOriginId: builder.opt(builder.str('dummyOriginId')),
    classification: builder.opt(new PropDesc_1.PropDesc(new Parser_1.StringMapParser(), {
      nameKey: Window.name + '_classification'
    })),
    derivedData: builder.obj('derivedData', WindowDerivedData_1.WindowDerivedData.schema, function (mat) {
      return new WindowDerivedData_1.WindowDerivedData(mat.leadingProductPrice, mat.leadingProductDiscount, mat.varyingPrice, mat.varyingDiscount);
    }),
    processed: builder.bool('processed'),
    warningFlags: builder.flags('warningFlags', WindowWarningFlag_1.WindowWarningFlag),
    snapshotOriginId: builder.opt(builder.str('snapshotOriginId')),
    source: builder.opt(builder.senum('source', CreationSource_1.CreationSource, CodebookLookupSequence_1.CodebookLookupSequence.CreationSource))
  };
}();